//@ts-nocheck
import { Badge, Table, TableCell } from "@factorearth/component-library";
import TabManager from "@factorearth/component-library/dist/Organisms/TabManager/TabManager";
import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { listUsers } from "graphql/queries";
import usePermission from "hooks/usePermission";
import useRole from "hooks/useRole";
import { useTheme } from "hooks/useSingleton";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { recordSentry } from "utils/recordSentry";
import PermissionForm from "./PermissionForm/PermissionForm";
import RoleForm from "./RoleForm/RoleForm";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { Role, User } from "db/definitions";

interface TeamManagerProps {
	online: boolean;
	userDoc: any;
}

const TeamManager = (props: TeamManagerProps) => {
	const navigate = useNavigate();
	const [users, setUsers] = useState<User[]>([]);
	const { createRole, updateRole, roles } = useRole({ online: props.online });
	const { createPermission, updatePermission, permissions } = usePermission({ online: props.online });
	const colorPalette = useTheme();

	const styles: React.CSSProperties = {
		display: "flex",
		flexDirection: "column",
		justifyContent: "start",
		alignItems: "flex-start",
		color: colorPalette.text.primary,
		padding: "8px 0px",
		cursor: "pointer",
	};

	useEffect(() => {
		const getUsers = async () => {
			let users: User[] = [];
			let nextToken;

			while (nextToken !== null) {
				const result = (await generateClient({ authMode: "userPool" }).graphql({
					query: listUsers,
					variables: { nextToken },
					authMode: "userPool",
				})) as GraphQLResult<{ listUsers: { items: User[]; nextToken: string | null } }>;
				nextToken = result.data.listUsers.nextToken;
				users = users.concat(result.data.listUsers.items);
			}
			return users;
		};
		const getAllUsers = async () => {
			try {
				const allUsers = await getUsers();
				setUsers(allUsers);
			} catch (error) {
				recordSentry({ error });
			}
		};
		getAllUsers();
	}, []);

	const columnConfiguration = [
		{
			key: "email",
			header: "Email",
			sortable: false,
			cell: (row: any) => (
				<TableCell
					colorPalette={colorPalette}
					style={styles}
					onClick={() => navigate(`/team-manager/edit-user-permissions/${row.id}`)}
					key={`email-cell-for-${row.id}`}>
					<div>{row.username}</div>
					<div>{row.email}</div>
				</TableCell>
			),
		},
		{
			key: "roles",
			header: "Roles",
			cell: (row: any) => {
				const roles = row.roles.map((role: Role) => (
					<Badge theme={colorPalette} variant={"filled"} label={role.name} style={{ padding: "4px 8px" }} key={role.id} />
				));
				return (
					<TableCell colorPalette={colorPalette} style={{ gap: "8px", padding: "8px 0px" }} key={`roles-cell-for-${row.id}`}>
						{roles}
					</TableCell>
				);
			},
			sortable: false,
		},
	];

	return (
		<div style={{ display: "flex", flexGrow: 1, flexDirection: "column", overflow: "auto", background: colorPalette.background.absolute }}>
			{users.length ? (
				<>
					<Table colorPalette={colorPalette} columnConfig={columnConfiguration} tableData={users} pageSize={10} />
					<TabManager
						colorPalette={colorPalette}
						tabLabels={["Roles", "Permissions"]}
						forms={[
							<RoleForm
								roles={roles}
								createRole={createRole}
								updateRole={updateRole}
								permissions={permissions}
								userDoc={props.userDoc}
								key={`role-form`}
							/>,
							<PermissionForm
								permissions={permissions}
								createPermission={createPermission}
								updatePermission={updatePermission}
								userDoc={props.userDoc}
								key={`permission-form`}
							/>,
						]}
					/>
				</>
			) : (
				<LoadingSpinner />
			)}
		</div>
	);
};

export default TeamManager;
